import type { WorkEventType } from '../../../services/employeeService';

export const WORK_EVENT_LABELS: Record<WorkEventType, string> = {
  ADMISSAO: 'Admissão',
  DEMISSAO: 'Demissão',
  AFASTAMENTO: 'Afastamento',
  RETORNO: 'Retorno',
  MUDANCA_CARGO: 'Mudança de cargo',
  MUDANCA_SETOR: 'Mudança de setor',
  MUDANCA_UNIDADE: 'Mudança de unidade',
  PROMOCAO: 'Promoção',
  TRANSFERENCIA: 'Transferência',
};

/** Tipo que o enum ainda não conhece aparece como veio, nunca em branco. */
export function rotuloDoEvento(tipo: string): string {
  return WORK_EVENT_LABELS[tipo as WorkEventType] ?? tipo;
}
